import { useEffect } from 'react';
import { FormikProps, useFormik } from 'formik';
import * as Yup from 'yup';

import { IZone } from 'models';
import { useZone } from 'pages/zones/zones.hook';
import { useApproveDecalMutation } from 'store/apis/decal.api';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';

interface UseDecalFormManagerProps {
  decalId: number; // zone.id
  next?: (data?: any) => void;
}

export const useDecalFormManager = ({ decalId: id, next = () => {} }: UseDecalFormManagerProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [loading_zone, zone] = useZone({ zoneId: id });
  const [mutate, { isLoading, isSuccess, isError, ...rest }] = useApproveDecalMutation();

  const initialValues = {};

  const validationSchema = Yup.object({});

  const formManager = useFormik({
    initialValues,
    validationSchema,
    onSubmit: () => {
      mutate({
        orgSlug,
        id,
      });
    },
  });

  useEffect(() => {
    if (!isLoading && isSuccess && !isError) {
      const { data } = rest;

      next(data);
    }
  }, [isLoading, isSuccess, isError]);

  return [
    {
      zone,
      formManager,
      loading_form: loading_zone,
      loading_submit: isLoading,
    },
  ] as [
    {
      zone: IZone;
      formManager: FormikProps<typeof initialValues>;
      loading_form: boolean;
      loading_submit: boolean;
    },
  ];
};
